import PageHeader from '../../shared/PageHeader'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import CustomTabs from '../../shared/CustomTabs'
import DoctorSummaryReport from './DoctorSummaryReport'
import DepartmentSummaryReport from './DepartmentSummaryReport'

export const doctorDepartmentSummaryReportTabs = t => [
  {
    name: t('Doctor Summary'),
    content: <DoctorSummaryReport />,
  },
  {
    name: t('Department Summary'),
    content: <DepartmentSummaryReport />,
  },
]

function DoctorDepartmentSummaryReport() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const prevActiveTab = state?.activeInvoiceTabIndex || 0

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <div className="flex items-center justify-between">
        <PageHeader
          title={t('Summary Reports')}
          iconSize={20}
          Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
          onIconClick={() => navigate(-1)}
        />
      </div>

      <div className="mt-2 w-full h-full">
        <CustomTabs
          tabs={doctorDepartmentSummaryReportTabs(t)}
          activeTabIndex={prevActiveTab}
        />
      </div>
    </div>
  )
}

export default DoctorDepartmentSummaryReport
